export enum LeaderBoardStatusType {
  New = 'new',
  Pending = 'pending',
  Active = 'active',
}

export enum LeagueType {
  Bronze = 'bronze',
  Silver = 'silver',
  Gold = 'gold',
  Diamond = 'diamond',
}

export const bronzeLeagueTopPlayersCount = 20;
export const silverLeagueTopPlayersCount = 10;
export const goldLeagueTopPlayersCount = 5;
export const diamondLeagueTopPlayersCount = 5;
export const losePlayersCount = 5;

export const leaguesWeightMap = {
  [LeagueType.Bronze]: 1,
  [LeagueType.Silver]: 2,
  [LeagueType.Gold]: 3,
  [LeagueType.Diamond]: 4,
};
